/*global FB*/
import React from 'react';
import ReactDOM from 'react-dom';
import {StyleRoot} from 'radium';

import {BrowserRouter} from 'react-router-dom';
import {IntlProvider} from 'react-intl';
import AppRouter from 'AppRouter';

import AppConstants from 'AppConstants';

import 'css/bootstrap-navbar.css';

import 'css/modal-custom.css';
import 'css/react-sidebar.css';
import 'css/mui-custom.css';

import 'css/global.css';
import 'css/custom.css';
import 'css/footer.css';
import 'css/docs.css';

import 'react-table/react-table.css';
import 'css/dashain-campaign.css';

import 'css/stock-page.css';
import 'css/admin.css';
import 'css/user.css';
import 'css/product.css';
import 'css/orders.css';
import 'css/payment.css';

import { StickyContainer } from 'react-sticky';

const appStyle= {
  minHeight: "500px",
  background: "#f5f5f5"
};




class App extends React.Component {

  constructor(props) {
    super(props);
    this.initFbSDK();
  }

  initFbSDK() {
    window.fbAsyncInit = function() {
        FB.init({
          appId            : AppConstants.FB_APP_ID,
          autoLogAppEvents : true,
          xfbml            : true,
          version          : 'v2.11'
        });
      };

      //Load the SDK asynchronously
      (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
  }

  render() {
    return (
      <IntlProvider locale="en">
        <StickyContainer>
          <div style={appStyle}>

            <StyleRoot>
                  <BrowserRouter>
                      <AppRouter />
                  </BrowserRouter>
              </StyleRoot>
          </div>
        </StickyContainer>
      </IntlProvider>
    );
  }
}


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error: error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({error: error});
  }

  render() {
    if (this.state.error) {
      
      // You can render any custom fallback UI
      return <div style={{background: "#eee", padding: "10px 0", textAlign: "center"}}>
                <h1>Opps! Something went wrong.</h1>

                <h3 style={{fontWeight: 'bold', margin: '10px 0'}}>Please DM us in Messenger to resolve the issue or to place your order.</h3>

                <div style={{margin: '20px'}}>
                  <a style={{padding: '10px', background: 'orange', color: 'white', border: "1px", fontSize: '130%'}} 
                      target="_blank" href="https://m.me/setocanvascom">Open Messenger</a>
                </div>

                <div style={{background: "#e45959"}}>
                  <h2 style={{background: '#c7c7c775', color: 'white', padding: '10px'}}>Error Stack - {this.state.error.toString()}</h2>
                  <div style={{color: "white", padding: "10px", whiteSpace: "pre-line"}}>
                    {this.state.error.stack}
                  </div>
                </div>
            </div>;
    }

    return this.props.children;
  }
}

ReactDOM.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>,
		document.getElementById('root')
		);



// WEBPACK FOOTER //
// ./src/index.js